import { Component, Input, input } from '@angular/core';

@Component({
  selector: 'reports-tooltip-header',
  template: `
    @if (color) {
      <div class="marker" [style.backgroundColor]="color"></div>
    }
    <span>
      {{ title() }}
    </span>
  `,
  styleUrls: ['./report-tooltip-header.component.less'],
  standalone: true,
})
export class ReportTooltipHeaderComponent {
  public readonly title = input<string>(undefined!);
  @Input() public color?: string;
}
